<template>
  <div v-if="pagetype">
    <div :class="`${$style.reserve_top} ${$style[pagetype]}`">
      <i v-if="isText"
        :class="$style.reserve_top_icon"
        class="fa-regular fa-comment-lines"/>
      <i v-if="isOnline"
        :class="$style.reserve_top_icon"
        class="fa-regular fa-laptop">
        <i :class="$style.reserve_top_icon_inner" class="fa-regular fa-user-headset"/>
      </i>
      <i v-if="isVirtual"
        :class="$style.reserve_top_icon"
        class="fa-solid fa-vr-cardboard"></i>
      <div
        v-if="content"
        v-html="content.top"
        :class="$style.reserve_top_text"></div>
    </div>
    <div :class="$style.content_top_wrap">
      <div :class="$style.content_top">
        <spacer :y="9" :sm-y="4" />
        <div :class="[$style.content_top_subtitle, isVirtual ? $style.virtual : null]">いつでも どこでも 気軽に 手軽に</div>
        <spacer :y="2"/>
        <div :class="$style.content_top_title">{{ content.content_title }}</div>

        <div v-if="helper && helper.textDisableStatus && helper.textDisableStatus.emphasis_notice && isText"
        :class="$style.notice">
          <spacer :y="3" :sm-y="3" />
          <emphasis-notice
            v-if="helper.textDisableStatus.emphasis_notice
              && helper.textDisableStatus.show_emphasis_notice"
            :message="helper.textDisableStatus.emphasis_notice" />
          <spacer :y="3" :sm-y="3" />
        </div>
        <spacer v-else :y="7" :sm-y="3" />
        <div :class="$style.content_top_text">
          <p v-html="content.description"></p>

          <template
            v-if="user?.school?.[0]?.textCount !== null
              && user?.school?.[0]?.textCount !== undefined
              && user?.school?.[0]?.textCount <= 0">
            <spacer :y="4" :sm-y="2" />
            <p style="font-weight: bold; color: #ff0000">{{ noCreditLabel }}</p>
          </template>

        </div>
        <spacer :y="9" :sm-y="4" />
      </div>
    </div>

    <div
      :class="$style.content"
      v-if="isOnlineOrVirtual && !schedule.id">
      <spacer :y="5"/>
      <data-grid>
        <data-detail>
          <btn-container>
            <basic-btn tag="a" @click="clickReserve">{{ reserveLabel }}</basic-btn>
          </btn-container>
        </data-detail>
      </data-grid>
      <spacer :y="5"/>
    </div>

    <div v-else :class="$style.content" id="confirm">
      <spacer :y="5"/>
      <!-- 企業(is_corporate): お悩み〜ココモニ〜送信の入力 UI はステップ化したウィザードが担う。
           非企業(学校/インターン)の旧1画面フォームは下に残置しており、学校まで全展開する際は
           この分岐と旧フローの要素を落とすだけで済む。先生/希望日時/VCID の各行はウィザードの
           確認ステップが持つため、企業経路ではここに出さない。
           分岐は v-else でなく明示条件で書く（間に要素が挿入されたとき v-else の対が
           silent にずれるのを避けるため）。 -->
      <!-- showWizard は master ロード後に真になる（お悩みラベル・ココモニ設問とも master 依存。
           旧フォームがお悩み行を helper.master.labels で伏せていたのと同じ前提） -->
      <reserve-form-wizard
        v-if="showWizard"
        :pagetype="pagetype"
        :schedule="schedule"
        :disabled="isText && isTextDisable"
        :has-progress="hasProgress"
        :has-client-virtual-cast-id="hasClientVirtualCastId"
        :is-sended="isSended"
        :verify-reservable="verifyStillAvailable"
        @submit="onWizardSubmit"
      />
      <data-grid v-if="showLegacyForm">
        <data-row v-if="isOnlineOrVirtual && schedule.data">
          <data-term width="quater">
            <label-box
              :class="$style.label"
              label="先生"
              :color="labelBoxColor"
            />
          </data-term>
          <data-detail>
            <div :class="$style.flex">
              <round-img width="50px" :src="getMyIconUrl(schedule.data.counselor)" />
              <spacer :x="1.5"/>
              <p><span :class="$style.bold">{{ schedule.data.counselor.username }}</span>先生（{{ helper.master.labels.users.account_type[schedule.data.counselor.account_type] }}）に相談</p>
            </div>
          </data-detail>
        </data-row>

        <data-row v-if="isVirtual && schedule.data">
          <data-term width="quater">
            <label-box
              :class="$style.label"
              label="Virtual Cast ID"
              :color="labelBoxColor"
            />
            <p
              v-if="!hasClientVirtualCastId"
              :class="$style.required"
            >※必須項目</p>
          </data-term>
          <data-detail>
            <template v-if="hasClientVirtualCastId">
              <p>{{ user.virtualCastProp.virtual_cast_id }}</p>
              <template v-if="!flag.isConfirm">
                <p :class="$style.annotation">
                  以下のリンクがご自分のアカウントか確認してください。<br>
                  <a :href="getVirtualCastUserURL(user.virtualCastProp.virtual_cast_id)" target="_blank">{{ getVirtualCastUserURL(user.virtualCastProp.virtual_cast_id) }}</a>
                </p>
                <p :class="$style.annotation">万が一間違えて登録してしまった場合は営業日3日前までに事務局へ連絡ください。</p>
              </template>
            </template>
            <template v-else>
              <div
                :class="[
                  $style.vcid,
                  flag.isConfirm ? null : $style.force_link
                ]"
                v-on:click="clickVcidInputButton"
              >
                <input-codes
                  :key="`regist-form-vcid-${virtual_cast_id}`"
                  :digit="6"
                  :value="virtual_cast_id"
                  :smallMode="true"
                  :readonly="true"
                />
              </div>
              <p
                v-if="virtual_cast_id"
                :class="$style.annotation"
              ><a :href="getVirtualCastUserURL(virtual_cast_id)" target="_blank">{{ getVirtualCastUserURL(virtual_cast_id) }}</a></p>
            </template>
          </data-detail>
        </data-row>

        <data-row v-if="isOnlineOrVirtual && schedule.data">
          <data-term width="quater">
            <label-box
              :class="$style.label"
              label="希望日時"
              :color="labelBoxColor"
            />
          </data-term>
          <data-detail>
            <div :class="`${$style.flex} ${$style.space}`">
              <p>{{ filterMoment(schedule.data.date, 'Y年MM月DD日') }}</p>
              <spacer :x="2"/>
              <p>{{ filterMoment(schedule.data.date, 'HH:mm') }} ~ {{ slotEndTime(schedule.data.date) }}</p>
            </div>
            <jst-time-note :date="schedule.data.date" />
          </data-detail>
        </data-row>

        <!-- text -->
        <data-row
          v-if="helper.master && helper.master.labels">
          <data-term width="quater">
            <label-box
              :class="$style.label"
              label="お悩み"
              :color="labelBoxColor"
            />
            <p :class="$style.required">※必須項目</p>
          </data-term>
          <data-detail>
            <!-- 非企業(学校/インターン)の従来 UI。企業(is_corporate)はウィザードへ移ったため、
                 プロトタイプ撤去時に一時縮退させていた企業向けブロックはここから撤去した。 -->
            <div :class="[$style.flex, { [$style.flexCompany]: isCompany }]">
              <div
                v-for="(item, value) in helper.master.labels.texts.type"
                :key="value"
                :class="$style.item"
                v-show="Number(value) < 6 && (!flag.isConfirm || selectItems.includes(value))">
                <input
                  v-if="!flag.isConfirm"
                  :disabled="flag.isConfirm || (isText && isTextDisable)"
                  type="checkbox"
                  :id="`${item}-${value}`"
                  :value="value"
                  :checked="selectItems.includes(value)"
                  v-on:change="updateCheckValue">
                <label
                  v-if="!flag.isConfirm || selectItems.includes(value)"
                  :for="`${item}-${value}`">{{ getWorryTypeLabel(value, isCompany, 'texts') }}</label>
              </div>
              <div :class="$style.item">
                <!-- selectItems は送信時まで文字列で保持される（submit で Number 変換）。
                     その他(6) も項目1-5・自由記述ブロックと同様に文字列 '6' で判定する。
                     数値 6 だと確認画面でラベルが消え自由記述だけ残る不整合になる -->
                <input
                  v-show="!flag.isConfirm"
                  :disabled="flag.isConfirm || (isText && isTextDisable)"
                  type="checkbox"
                  id="other"
                  value="6"
                  :checked="selectItems.includes('6')"
                  @change="updateCheckValue">
                <label v-if="!flag.isConfirm || selectItems.includes('6')" for="other">その他</label>
              </div>
            </div>
            <template v-if="selectItems.includes('6')">
              <spacer :y="1"/>
              <label
                for="other_text"
                class="n2br"
              >
                <p
                  :class="$style.other_text_label"
                  v-if="!flag.isConfirm">内容を入力してください</p>
                <input
                  v-if="!flag.isConfirm"
                  :class="$style.input_text"
                  type="text"
                  v-model="other_text">
                <p v-else>（{{ other_text }}）</p>
              </label>
            </template>
          </data-detail>
        </data-row>

        <data-row>
          <data-term width="quater">
            <label-box
              :class="$style.label"
              label="相談内容"
              :color="labelBoxColor"
            />
            <!-- 必須は text のみ（オンライン/バーチャルは事前情報の任意入力）。
                 必須チェック側の isText と同じ軸にする＝軸ズレによる表示と実態の乖離を作らない -->
            <p
              v-if="isText"
              :class="$style.required"
            >※必須項目</p>
            <p :class="$style.annotation">※絵文字や機種依存文字は文字化けの原因になります。<br> ご利用を避け、テキストのみご入力ください。</p>
          </data-term>
          <data-detail>
            <textarea
              :class="$style.textarea"
              name="textarea"
              id="textarea"
              v-model="message"
              rows="20"
              :disabled="flag.isConfirm || (isText && isTextDisable)"
              v-on:input="updateValue"
              :placeholder="isOnlineOrVirtual ? '担当の医師・心理士に伝えておきたい相談内容があればご記入ください。': ''"></textarea>
            <div :class="$style.count">
              <p :class="{ [$style.red] : flag.over600 }">600字以内で入力してください。</p>
              <p>{{ textCount }}/<span :class="$style.bold">600</span></p>
            </div>
          </data-detail>
        </data-row>

        <data-row v-if="helper.master && helper.master.who5">
          <data-term width="quater">
            <label-box
              :class="$style.label"
              label="ココモニチェック"
              :color="labelBoxColor"
            />
            <p :class="$style.required">※必須項目</p>
          </data-term>
          <data-detail v-if="helper.master">
            <StackItem
              v-for="(item, i) in helper.master.who5.items"
              :key="i"
              :class="$style.who5item">
              <basic-box type="inner">
                <div :class="$style.who5itemTitle"><span>Q{{ i + 1 }}.</span> {{item.label}}</div>
                <spacer :y="1" />
                <ul :class="$style.optionList">
                  <li
                    v-for="(option, j) in helper.master.who5.options"
                    :key="`${i}-${j}`"
                    :class="$style.optionItem"
                  >
                    <input
                      type="radio"
                      :id="`${i}-${j}`"
                      :name="`who${i}`"
                      v-on:change="updateRadioValue(i, option.value)"
                      :disabled="flag.isConfirm || (isText && isTextDisable)">
                    <label :for="`${i}-${j}`">{{ option.label }}</label>
                  </li>
                </ul>
              </basic-box>
            </StackItem>
          </data-detail>
        </data-row>
      </data-grid>
      <spacer v-if="showLegacyForm" :y="4" />
      <btn-container v-if="showLegacyForm">
        <basic-btn tag="button" v-if="!flag.isConfirm" v-on:click="checkConfirm" :disabled="isText && isTextDisable">相談内容を確認する</basic-btn>
        <basic-btn tag="button" v-if="flag.isConfirm" v-on:click="changeFlag" :disabled="isText && isTextDisable">戻る</basic-btn>
        <spacer :x="2"/>
        <basic-btn tag="button" v-if="flag.isConfirm" v-on:click="submit" :disabled="isText && isTextDisable || isSended">送信する</basic-btn>
      </btn-container>
      <spacer :y="8.5"/>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { calcAgeFromBirthday } from '@/lib/dateParts';
import BasicBtn from '@/views/components/BasicBtn.vue';
import BtnContainer from '@/views/components/BtnContainer.vue';
import RoundImg from '@/views/components/RoundImg';
import LabelBox from '@/views/components/LabelBox';
import JstTimeNote from '@/views/components/JstTimeNote.vue';
import Spacer from '@/views/components/Spacer.vue';
import BasicBox from '@/views/components/BasicBox.vue';
import StackItem from '@/views/components/StackItem.vue';
import EmphasisNotice from '@/views/components/EmphasisNotice.vue';
import InputCodes from '@/views/components/parts/Form/InputCodes.vue';
import {
  DataGrid, DataRow, DataTerm, DataDetail,
} from '@/views/components/DataGrid';
import ReserveFormWizard from '@/views/pages/User/parts/ReserveFormWizard.vue';
import cf from '@/mixins/commonFunctions';
import corporateSchool from '@/mixins/corporateSchool';
import userState from '@/mixins/userState';

export default {
  name: 'reserve-form',
  mixins: [cf, corporateSchool, userState],
  components: {
    BasicBtn,
    BtnContainer,
    BasicBox,
    RoundImg,
    LabelBox,
    Spacer,
    StackItem,
    DataGrid,
    DataRow,
    DataTerm,
    DataDetail,
    EmphasisNotice,
    JstTimeNote,
    InputCodes,
    ReserveFormWizard,
  },
  data() {
    return {
      flag: {
        isConfirm: false,
        over600: false,
      },
      schedule: {
        id: null,
        data: null,
      },
      // 予約可否の再チェックで一度 NG（予約済み/満席）を検知したら立てる一方向ラッチ。
      // ステップ移動の非同期チェックが連打で複数走っても、二重 alert／二重 backToSlotList を抑止する。
      reservableCheckFailed: false,
      // 受付停止の再チェックで一度 NG を検知したら立てる一方向ラッチ（reservableCheckFailed のテキスト版）。
      textStoppedDetected: false,
      pagetype: null,
      content: {},
      contents: {
        text: {
          top: 'テキスト健康相談',
          content_title: '書いてみよう',
          description: 'マイページから、いつでも気軽に相談可能。心理士とのメッセージのやり取りを通じて、不安な気持ちや悩みを書き出すことができます。回答のあった心理士との面談（オンライン健康相談）予約も簡単ラクラク！<br>※相談する心理士の指定はできません。<br>※相談内容の送信から営業日2日以内に担当心理士より回答が届きます。<br><br>Welcome to talk 営業日: 平日13:00-22:00<br>(土日祝日、年末年始を除く)<br>　例1)平日金曜に送信>>翌週の火曜日までに回答<br>　例2)平日金曜に送信、翌週月曜が祝日>>翌週の水曜までに回答<br>　例3)平日水曜に送信、翌日木曜が祝日>>翌週の月曜までに回答',
        },
        online: {
          top: 'オンライン健康相談',
          content_title: '話してみよう',
          description: 'テレビ会議システムを用いた1対1のプライベート空間で、希望の心理士もしくは医師の顔を見ながら安心して相談ができます。営業日３日後から最大翌月末までの予約が可能！好きな場所から、好きな時間に（13:00-22:00）、どんな些細なことでも気軽にご相談ください。<br>※Zoomアプリケーションのダウンロードが必要です。',
        },
        virtual: {
          top: 'バーチャル健康相談',
          content_title: 'バーチャル空間で会いましょう',
          description: 'MetaQuestを用いたバーチャル空間で、相談体験をしてみませんか？<br>'
            + '悩みやモヤモヤをテキストで書くのが苦手…、オンライン上でも顔を見せて話すのは緊張する…、テキスト健康相談やオンライン健康相談を始めていない方も、バーチャル空間ならいつもと違った体験になるかもしれません。<br>'
            + '自分の好きなアバターで、好きな時間に（13:00-22:00）、Welcome to talkの専門家（医師・心理士）がバーチャル空間でお待ちしています。<br>'
            + '<br>'
            + '【バーチャル健康相談をご利用いただくために】<br>'
            + '※MetaQuest VRヘッドセットが必要です<br>'
            + '※お手持ちのMeta Quest2またはMeta Quest3の設定<br>'
            + '※バーチャルキャスト（VC）のログインID取得/ルームのお気に入り設定',
        },
      },
      other_text: null,
      message: null,
      selectItems: [],
      // 企業ユーザー向け: メイン番号（1-5）→ 選択されたサブ番号配列
      selectSubItems: {
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
      },
      textCount: 0,
      isSended: false,
      who5Answers: [null, null, null, null, null],
      virtual_cast_id: null,
    };
  },
  created() {
    const path = this.$route.path.split('/');
    this.pagetype = path[2];
    this.content = this.contents[this.pagetype];

    if (['online', 'virtual'].includes(this.pagetype)) {
      // schedule_idからカウンセラーとシフト情報取得
      const query = this.$route.query;
      if (query.schedule_id && cf.convert2Num(query.schedule_id)) {
        this.schedule.id = cf.convert2Num(query.schedule_id);
        this.getScheduleData();
      }
    } else if (this.pagetype === 'text') {
      // 流入時の受付停止チェック。停止非連動の導線（TOP スライダー・案内ページ）や、停止前に開いた
      // タブ・直 URL・戻る/進む等、全流入経路でこの画面に到達しうるため、online/virtual の
      // getScheduleData と同じく都度 fetch した新鮮な値で判定する。await しない（＝背景チェック）のは
      // online 側と揃えるため。NG なら案内してテキスト相談タブへ戻す。
      this.verifyTextCounselingStillOpen();
    }
  },
  computed: {
    ...mapState(['helper', 'user']),
    // 所属校が企業アカウント（is_company=1）か。企業向けお悩みラベル/サブ説明文の出し分けに使用
    isCompany() {
      return !!this.user?.school?.[0]?.is_company;
    },
    // 企業固有のお悩みサブ項目「入力」UI ゲート専用（企業＝is_company かつ is_corporate）。
    // インターン(id=18)では false → サブ項目チェック UI を出さず sub_type を送らせない。ラベル(#3238)は isCompany 据え置き。
    isCorporate() {
      return this.isCorporateSchool(this.user?.school);
    },
    // 企業はウィザード、非企業は旧1画面フロー。両者は相互排他で、user 解決までどちらも出さない
    // （解決前は user.school 未定義で isCorporate が偽側へ倒れ、企業利用者に旧フローが一瞬出る FOUC）。
    // user 解決判定は userState mixin の isUserResolved に集約（判定軸の理由は mixin の doc 参照）。
    // 学校まで全展開する際は showLegacyForm と旧フローの要素を落とすだけで済む。
    showWizard() {
      return this.isUserResolved(this.user) && this.isCorporate && !!this.helper.master?.labels;
    },
    showLegacyForm() {
      return this.isUserResolved(this.user) && !this.isCorporate;
    },
    // オンライン同時刻上限。backend が env の Zoom アカウント実数から導出し getMaster で注入した値。
    // master 未ロード時は安全側(prod 相当)の 2 にフォールバック。
    onlineSameTimeLimit() {
      return (this.helper.master && this.helper.master.onlineSameTimeLimit) || 2;
    },
    isText() {
      return this.pagetype === 'text';
    },
    isOnline() {
      return this.pagetype === 'online';
    },
    isVirtual() {
      return this.pagetype === 'virtual';
    },
    isOnlineOrVirtual() {
      return this.isOnline || this.isVirtual;
    },
    isRegist() {
      let flag = true;
      // お悩みを選択しているか
      if (!this.selectItems.length) flag = false;
      // 相談内容が600字以内に収まっているか
      if (this.textCount > 600) flag = false;
      // 質問票に回答しているか
      this.who5items.forEach((item) => {
        if (item.value === null) {
          flag = false;
        }
      });
      return flag;
    },
    hasProgress() {
      let flag = false;
      if (this.user.counseling
      && this.user.counseling.texts
      && this.user.counseling.texts.progress
      && this.user.counseling.texts.progress.length) {
        flag = true;
      }
      return flag;
    },
    hasFutureReservation() {
      let flag = false;
      if (this.user.counseling
      && this.user.counseling.reserves
      && this.user.counseling.reserves.future
      && this.user.counseling.reserves.future.length) {
        flag = true;
      }
      return flag;
    },
    reserveLabel() {
      return this.hasFutureReservation ? '予約状況を確認する' : '相談する先生を選ぶ';
    },
    // 相談時点の年齢（reserves.customer_age / messageGroups.customer_age に載せるスナップショット）。
    // 算出は共通ヘルパーに集約している。生年月日が無い・判定できない場合は null になり、
    // サーバ側が customer_age の欠落として弾く（従来の返り値と同じ扱い）。
    calcCustomerAge() {
      return calcAgeFromBirthday(this.user.birthday);
    },
    isTextDisable() {
      let flag = false;
      if (
        (
          this.helper
            && this.helper.textDisableStatus
            && this.helper.textDisableStatus.disable_text_counseling
        )
      || (
          this.user?.school?.[0]?.textCount !== null
            && this.user?.school?.[0]?.textCount !== undefined
            && this.user?.school?.[0]?.textCount <= 0
      )) {
        flag = true;
      }
      return flag;
    },
    hasClientVirtualCastId() {
      return this.user.virtualCastProp ? !!this.user.virtualCastProp.virtual_cast_id : false;
    },
    labelBoxColor() {
      return this.isVirtual ? 'green' : null; // null = defaultのorangeが採用される
    },
    noCreditLabel() {
      const contact = this.user.school[0].is_company ? 'プログラムのご担当者' : '学校';
      return `ご利用上限回数に達しているため受付できません。${contact}にお問い合わせください。`;
    },
  },
  methods: {
    ignores() {
      let result = false;
      const ignoreSchools = [];
      if (ignoreSchools.includes(this.user.school[0].id)) result = true;
      return result;
    },
    /** ローディング表示 */
    showLoading() {
      const args = { modalName: 'modalLoadingBallScaleRippleMultiple' };
      this.$store.dispatch('modal/loadings/showModal', args, { root: true });
    },
    /** ローディング非表示 */
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },
    async checkConfirm() {
      // テキスト相談の場合の独自チェック
      if (this.isText && this.hasProgress) {
        alert('相談中のやりとりが残っているため、新たに相談内容を登録することはできません。');
        return;
      }
      // 確認画面遷移時の申込可否チェック（online/virtual=予約済み再確認＋同時刻満席 / text=受付停止）。
      // 同期（ブロッキング）で通す。NG なら各チェックが alert＋戻すので、ここでは中断のみ。
      if (!(await this.verifyStillAvailable())) return;
      // バーチャル健康相談の場合の独自チェック
      if (this.isVirtual && !this.hasClientVirtualCastId && !this.virtual_cast_id) {
        alert('Virtual Cast ID を入力してください。');
        return;
      }

      let valid = true;

      if (!this.selectItems.length) {
        alert('お悩みの種別を選択してください');
        valid = false;
      }

      if (Object.values(this.selectItems).includes('6') && !this.other_text) {
        alert('お悩みのその他の内容を入力してください');
        valid = false;
      }

      // サブ必須（#3242）の判定はウィザード側が持つ。この旧1画面フローが担当するのは
      // 非企業（学校/インターン）だけで、サブ項目の入力 UI 自体が存在しないため、ここで
      // 必須チェックを走らせるとインターン利用者が確定不能になる（ゲート軸が入力 UI の
      // 表示ゲート isCorporate と揃っていないことによる false-block）。
      // 不変条件: サブ必須チェックの発火軸は、サブ入力 UI の表示ゲートと同軸でなければならない。

      if (this.isText && !this.message) { // テキスト健康相談
        alert('相談内容を入力してください');
        valid = false;
      }
      if (this.flag.over600) {
        alert('相談内容は600字以内で入力してください。');
        valid = false;
      }

      // who5はすべて埋まっている必要がある
      this.who5Answers.some((score) => {
        if (score === null) {
          alert('ココモニチェックはすべて回答してください');
          valid = false;
          return true;
        }
        return false;
      });
      if (valid) this.changeFlag();
    },

    changeFlag() {
      this.flag.isConfirm = !this.flag.isConfirm;
      if (this.flag.isConfirm) {
        const elem = document.getElementById('confirm');
        const position = elem.getBoundingClientRect().top;
        scrollBy(0, position - 77);
      }
    },

    updateValue(e) {
      const val = e.target.value;
      this.textCount = val.length;
      if (this.textCount > 600) this.flag.over600 = true;
      else this.flag.over600 = false;
    },

    // 非企業（学校/インターン）の1画面フォームで 1-5 とその他(6) の手動トグルを扱う。
    // 企業(is_corporate)はウィザードへ移ったためこのハンドラを通らない。
    updateCheckValue(e) {
      if (this.selectItems.includes(e.target.value)) {
        const idx = this.selectItems.indexOf(e.target.value);
        this.selectItems.splice(idx, 1);
        // メインを外したらそのメイン配下のサブもクリア（オブジェクト全体差し替えで reactivity に乗せる）
        this.selectSubItems = { ...this.selectSubItems, [e.target.value]: [] };
      } else {
        this.selectItems.push(e.target.value);
      }
    },
    /**
     * ウィザード（企業）から入力値一式を受け取って既存の送信経路へ流す。
     * 保存契約（counseling_type / who5Data の組み立て）は submit に一本化したままにし、
     * ウィザード側へ複製しない。
     */
    onWizardSubmit(payload) {
      this.selectItems = payload.selectItems;
      this.selectSubItems = payload.selectSubItems;
      this.other_text = payload.other_text;
      this.message = payload.message;
      this.who5Answers = payload.who5Answers;
      this.virtual_cast_id = payload.virtual_cast_id;
      this.submit();
    },
    // selectSubItems から API 送信用の {メイン番号文字列: [サブ番号]} を組み立てる。
    // 選択中メインのみ含め、メイン6（その他）は除外する。
    buildSubTypesPayload() {
      const result = {};
      this.selectItems.forEach((typeNum) => {
        const num = Number(typeNum);
        if (num === 6) return;
        const subs = (this.selectSubItems[typeNum] || []).map(Number);
        if (subs.length) result[String(num)] = subs;
      });
      return result;
    },

    updateRadioValue(i, value) {
      this.who5Answers[i] = value;
    },

    async submit() {
      // オンライン相談の場合の同時刻満席チェック（online のみ・virtual は backend の重複ガードが担保）
      if (this.isOnline) {
        // 同時間帯での予約数チェック
        if (!(await cf.methods.checkOnlineReserveTime(this.schedule.data.date, this.onlineSameTimeLimit))) {
          // 満席（枠が埋まった）→ フォームに留まる理由がないため枠一覧へ戻す
          this.backToSlotList();
          return;
        }
      }

      this.showLoading();
      // selectItemsの中身をparseIntする
      this.selectItems.forEach((item, i) => {
        this.selectItems[i] = Number(item);
      });

      // VCIDの登録
      if (this.isVirtual && !this.hasClientVirtualCastId) {
        try {
          await this.axios({
            method: 'POST',
            url: '/v1/user/set/update',
            data: {
              id: this.user.id,
              account_type: this.user.account_type,
              virtualCastProp: {
                virtual_cast_id: this.virtual_cast_id,
              },
            },
          });
        } catch (error) {
          alert('Virtual Cast ID の登録に失敗しました。');
          console.error(error);
          return;
        }
      }

      let data = {};
      let modelName = 'messageGroup';
      if (this.isOnlineOrVirtual) { // オンライン/バーチャル健康相談
        modelName = 'reserve';
        // 必須項目
        data = {
          from_user_id: this.user.id,
          to_user_id: this.schedule.data.counselor.id,
          schedule_id: this.schedule.id,
          customer_age: this.calcCustomerAge,
          customer_school_type: this.user.school[0].school_type,
          customer_school_year: this.user.school_year,
          counseling_type: {
            type: this.selectItems,
            text: this.other_text || null,
            // 企業ユーザーのみ実値。学校ユーザーや未選択時は空オブジェクト（バック側で NULL 保存）
            sub_type: this.buildSubTypesPayload(),
          },
          who5Data: {
            answers: this.who5Answers,
          },
          is_virtual: this.isVirtual ? 1 : 0,
        };
        // 追加データ
        // if (this.other_text) data.other_text = this.other_text;
        if (this.message) data.memoData = { memo: this.message };
      } else if (this.isText) {

        // テキスト利用可能回数確認
        const billingType = this.user.school[0].billing_type.billing_type || null;
        let remaining;
        if (billingType && billingType === 1 && !this.ignores()) {
          if (this.user.school[0].textCount < 1) remaining = 0;
          else if (this.user.school[0].textCount !== 0) remaining = this.user.school[0].textCount || null;
        } else if (billingType === 2 && !this.ignores()) {
          remaining = 10; // サステナブルプランは無制限だが、backendへremainingを渡さないと跳ねられてしまうため模擬的にセット
        }

        // 必須項目
        data = {
          user_id: this.user.id,
          target_type: 1, // テキスト健康相談
          customer_age: this.calcCustomerAge,
          customer_school_type: this.user.school[0].school_type,
          customer_school_year: this.user.school_year,
          counseling_type: {
            type: this.selectItems,
            text: this.other_text || null,
            // 企業ユーザーのみ実値。学校ユーザーや未選択時は空オブジェクト（バック側で NULL 保存）
            sub_type: this.buildSubTypesPayload(),
          },
          messageData: {
            user_id: this.user.id,
            message: this.message,
          },
          who5Data: {
            answers: this.who5Answers,
          },
          remaining,
        };
      }

      const endpoint = `/v1/${modelName}/set/register`;
      this.axios({
        method: 'POST',
        url: endpoint,
        data,
      })
        .then((response) => {
          // オンライン/バーチャル
          if (this.isOnlineOrVirtual) {
            // エラー処理
            if (response.data.exists) {
              // 予約重複（この枠は既に予約されている）→ フォームに留まる理由がないため枠一覧へ戻す
              alert(`${cf.methods.filterMoment(this.schedule.data.date, 'YYYY年MM月DD日')}の${cf.methods.filterMoment(this.schedule.data.date, 'HH:mm')}${cf.methods.jstSlotSuffix(this.schedule.data.date)}の時間帯は、すでにご予約が入っています。お手数ですが、別の日時をお選びください。`);
              this.backToSlotList();
              return false;
            }
            if (response.data.noCountsLeft) {
              // 残カウント不足（枠でなくアカウント側の事由）→ 従来どおり同画面に留める
              alert(this.noCreditLabel);
              return false;
            }
            if (response.data.virtualReserveDuplicated) {
              // バーチャル健康相談の開始時刻重複（この枠は使えない）→ 枠一覧へ戻す
              alert('この時間帯は、すでに他のご予約が入っているため、お選びいただけません。お手数ですが、別の日時をお選びください。');
              this.backToSlotList();
              return false;
            }
            if (response.data.onlineReserveFull) {
              // オンライン健康相談の同時刻上限（Zoom owner/member=2枠）到達。backend が保存・Zoom 呼び出し前に
              // 穏当拒否（200）で返すため、成功処理へ進ませず、満席メッセージ表示後に枠一覧へ戻す。
              alert('この時間帯は、ほかの方のご予約が入ったため、お選びいただけません。お手数ですが、別の日時をお選びください。');
              this.backToSlotList();
              return false;
            }
            if (response.data.scheduleInvalid) {
              // 予約枠が無効（フォーム表示後にカウンセラーが取消した等）。backend は予約を作らず
              // graceful reject（status 200・reserveId 無し）で返すため、成功処理へ進ませず枠一覧へ戻す。
              alert('選択された日時は、現在ご予約を受け付けできない状態です。お手数ですが、別の日時をお選びください。');
              this.backToSlotList();
              return false;
            }
            // 正常処理
            this.onlineCounselingContact(response.data.reserveId);
            alert(`${cf.methods.filterMoment(this.schedule.data.date, 'YYYY年MM月DD日')}の${cf.methods.filterMoment(this.schedule.data.date, 'HH:mm')}${cf.methods.jstSlotSuffix(this.schedule.data.date)}にてご予約を承りました。`);
            // 作成の連絡
          }
          // テキスト
          if (this.isText) {
            // const billingType = this.user.school[0].billing_type.billing_type || null;

            if (response.data.noCountsLeft) {
              alert(this.noCreditLabel);
              return false;
            }

            if (response.data.textCounselingStopped) {
              // 流入時・確認ステップ進入時のチェックをすり抜けた（その後に停止された）場合の最終ゲート。
              // backend が保存前に穏当拒否（200）で返すため成功処理へ進ませず、枠が無効になったときの
              // scheduleInvalid と同じくテキスト相談タブへ戻す。
              // ストアの停止状態も取り直す。更新しないと戻った先のタブが「受付中」のままになり、
              // 同じ導線をもう一度たどれてしまう。
              this.$store.dispatch('helper/getTextDisableStatus');
              this.notifyTextCounselingStopped();
              return false;
            }

            alert('テキスト健康相談を投稿しました。2営業日以内に担当心理士より返答を行います。');
            this.isSended = true;
            // 作成の連絡
            this.textCounselingContact(response.data.group_id);
            if (this.user
              && this.user.school[0]
              && this.user.school[0].billing_type.billing_type === 1
              && !this.ignores()) {
              this.registTextCountHistories(response.data.group_id);
            }
          }
        })
        .catch((error) => {
          if (this.isOnline) {
            alert('オンライン健康相談の予約登録に失敗しました。お手数ですが管理者までお知らせください。');
          } else if (this.isVirtual) {
            alert('バーチャル健康相談の予約登録に失敗しました。お手数ですが管理者までお知らせください。');
          } else {
            alert('テキスト健康相談登録に失敗しました。お手数ですが管理者までお知らせください。');
          }
          this.failedContact(error);
        })
        .finally(() => {
          this.hideLoading();
          // 予約storeの更新
          this.$store.dispatch('user/counseling/getCounseling', null, { root: true });
        });
    },

    getScheduleData() {
      this.axios({
        method: 'GET',
        url: '/v1/schedule/get/detail',
        params: {
          id: this.schedule.id,
        },
      })
        .then((response) => {
          this.schedule.data = response.data.schedule;
          // 流入時の同一スケジュール予約済み早期ガード。stale 一覧クリック・直 URL・bfcache・戻る/進む
          // 等の全流入経路で、既に有効予約（reserve.flag===1）が入った枠に到達しうる。都度 fetch した
          // 新鮮な detail（Schedule.get が reserve を eager-load 済み）で判定し、お悩み等を入力する前に
          // 通達して先生選択一覧へ戻す。送信時の backend exists 重複チェックは最終ゲートとして温存。
          if (this.isOnlineOrVirtual
            && this.schedule.data
            && this.schedule.data.reserve
            && this.schedule.data.reserve.flag === 1) {
            alert('この時間帯は、すでにご予約が入っています。お手数ですが、別の日時をお選びください。');
            this.backToSlotList();
          }
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
        });
    },

    /**
     * 対象 schedule が今も予約可能か（＝予約済みでない・online なら同時刻満席でない）を再確認する。
     * online/virtual のみ実 fetch。テキストは枠を持たないため常に true。
     * NG（予約済み/満席）を検知したら alert して枠一覧へ戻し false を返す。二重発火は
     * reservableCheckFailed ラッチで抑止する。呼出側で await すれば同期（ブロッキング）、
     * await しなければ非同期（背景チェック・進行を妨げない）として使える。
     * fetch 失敗はフォームに留め、送信時 backend 重複チェックを最終ゲートに委ねる（過剰遷移を避ける）。
     * @returns {Promise<boolean>} 予約可能なら true
     */
    async verifyScheduleStillReservable() {
      if (!this.isOnlineOrVirtual || !this.schedule.id) return true; // テキスト/枠未確定はスキップ
      if (this.reservableCheckFailed) return false; // 既に NG 検知済みなら二重 alert/redirect を抑止
      try {
        // 1) 予約済み再チェック（新鮮な detail を都度 fetch）。reserve は Schedule.get が eager-load 済み。
        const response = await this.axios({
          method: 'GET',
          url: '/v1/schedule/get/detail',
          params: { id: this.schedule.id },
        });
        const fresh = response.data.schedule;
        if (fresh) this.schedule.data = fresh; // 表示も最新化
        if (fresh && fresh.reserve && fresh.reserve.flag === 1) {
          this.reservableCheckFailed = true;
          alert('この時間帯は、すでにご予約が入っています。お手数ですが、別の日時をお選びください。');
          this.backToSlotList();
          return false;
        }
        // 2) online のみ同時刻満席チェック（virtual は「同時刻1件で重複」＝上の reserve.flag が兼ねる）。
        if (this.isOnline
          && this.schedule.data
          && !(await cf.methods.checkOnlineReserveTime(this.schedule.data.date, this.onlineSameTimeLimit))) {
          this.reservableCheckFailed = true; // checkOnlineReserveTime が alert 済み
          this.backToSlotList();
          return false;
        }
        return true;
      } catch (error) {
        if (error && error.response) console.log(error.response.data);
        else console.log(error);
        return true;
      }
    },

    // 予約続行不可（枠が埋まった/予約済み/枠無効等）になったら、フォームに留まる理由がないため
    // 枠一覧へ戻す。入力内容は保持しないため、別枠を選び直した場合は再入力になる。
    backToSlotList() {
      this.$router.replace({ path: `/reserve/select/${this.pagetype}` });
    },

    /** 受付停止を検知したときの戻り先。テキストは枠一覧を持たないため相談タブへ戻す。 */
    backToTextTab() {
      this.$router.replace({ path: '/', query: { tab: 'text' } });
    },

    /**
     * 受付停止を検知したときの共通処理（案内 → テキスト相談タブへ戻す）。
     * 流入時・確認ステップ進入時・送信時の 3 箇所から呼ぶため、文言と戻り先をここに一本化する。
     * 次の行動は案内せず戻り先のタブに委ねる（戻った先が「受付停止中」表示になる）。
     * 呼び出し側は、ストアの停止状態が古い可能性があるなら事前に取り直しておくこと。
     */
    notifyTextCounselingStopped() {
      this.textStoppedDetected = true; // 二重 alert/redirect を抑止する一方向ラッチ
      alert('現在、テキスト健康相談の受付を一時停止しています。');
      this.backToTextTab();
    },

    /**
     * テキスト健康相談が今も受付中か（＝事務局が受付を停止していないか）をサーバの最新値で再確認する。
     * text のみ実 fetch。online/virtual における verifyScheduleStillReservable と同じ位置づけで、
     * 流入時・確認ステップ進入時・送信時の 3 点に配置する（送信時は backend が最終ゲート）。
     * 停止フラグはアプリ起動時に取得したきりで画面を開いたままだと古くなるため、ここで取り直す。
     * ストアを更新しておくと、戻った先のタブが「受付停止中」表示に切り替わる。
     * 二重 alert/redirect は textStoppedDetected ラッチで抑止する。
     * fetch 失敗はフォームに留め、送信時 backend の停止チェックを最終ゲートに委ねる（過剰遷移を避ける）。
     * @returns {Promise<boolean>} 受付中なら true
     */
    async verifyTextCounselingStillOpen() {
      if (!this.isText) return true;
      if (this.textStoppedDetected) return false; // 既に NG 検知済みなら二重 alert/redirect を抑止
      try {
        await this.$store.dispatch('helper/getTextDisableStatus');
        if (this.helper
          && this.helper.textDisableStatus
          && this.helper.textDisableStatus.disable_text_counseling) {
          // 直前の dispatch でストアは最新化済みのため、ここでは取り直さない
          this.notifyTextCounselingStopped();
          return false;
        }
        return true;
      } catch (error) {
        if (error && error.response) console.log(error.response.data);
        else console.log(error);
        return true;
      }
    },

    /**
     * この相談を今も申し込めるかの統合入口。online/virtual は枠（予約済み・同時刻満席）、
     * text は事務局の受付停止を見る。ウィザード（企業利用者）と旧フォームの双方がここを通る。
     * @returns {Promise<boolean>} 申し込み可能なら true
     */
    async verifyStillAvailable() {
      if (this.isText) return this.verifyTextCounselingStillOpen();
      return this.verifyScheduleStillReservable();
    },

    /** テキスト健康相談の連絡 */
    textCounselingContact(groupId) {
      // 利用者へ連絡
      this.axios({
        method: 'POST',
        url: '/v1/contact/regist/text/user',
        data: { group_id: groupId },
      })
        .then((response) => {
          if (this.helper.env.name === 'local') {
            console.log(response.data);
          }
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        });

      // 心理士へ連絡
      this.axios({
        method: 'POST',
        url: '/v1/contact/regist/text/counselor',
        data: { group_id: groupId },
      })
        .then((response) => {
          if (this.helper.env.name === 'local') {
            console.log(response.data);
          }
          // トップへリダイレクト
          this.$router.push({
            path: '/',
            query: { tab: 'text' },
          });
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        });
    },

    registTextCountHistories(groupId) {
      const data = {
        school_id: this.user.school[0].id,
        group_id: groupId,
        count: 1,
        is_add: 0,
      };

      this.axios({
        method: 'POST',
        url: '/v1/count/historyText/set/register',
        data,
      })
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        });
    },

    /** オンライン健康相談の連絡 */
    onlineCounselingContact(reserveId) {
      // 利用者へ連絡
      this.axios({
        method: 'POST',
        url: '/v1/contact/regist/online/user',
        data: { reserve_id: reserveId },
      })
        .then((response) => {
          if (this.helper.env.name === 'local') {
            console.log(response.data);
          }
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        });

      // 心理士へ連絡
      this.axios({
        method: 'POST',
        url: '/v1/contact/regist/online/counselor',
        data: { reserve_id: reserveId },
      })
        .then((response) => {
          if (this.helper.env.name === 'local') {
            console.log(response.data);
          }
          // トップへリダイレクト
          this.$router.push({
            path: '/',
            query: { tab: this.isVirtual ? 'virtual' : 'online' },
          });
          // 強制リロード（TODO: storeの変更を検知してupdateしたい）
          setTimeout(() => { this.$router.go(this.$router.currentRoute.path); }, 500);
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        });
    },

    clickReserve() {
      const pathKey = this.isVirtual ? 'virtual' : 'online';
      const path = this.hasFutureReservation ? `/?tab=${pathKey}` : `/reserve/select/${pathKey}/`;
      this.$router.replace(path);
    },

    /** VCID入力モーダルを開く */
    clickVcidInputButton() {
      if (this.flag.isConfirm) {
        return;
      }
      const args = {
        modalName: 'input-vcid',
        data: {
          callback: (vcid) => {
            this.virtual_cast_id = vcid;
          },
        },
      };
      this.$store.dispatch('modal/contents/showModal', args, { root: true });
    },

    /** 予約失敗時の連絡 */
    failedContact(error) {
      this.axios({
        method: 'POST',
        url: '/v1/contact/regist/failure',
        data: { error },
      })
        .then((response) => {
          console.log(response);
        })
        .catch((e) => {
          if (e.response) console.log(e.response.data);
          else console.log(e);
        });
    },
  },
};
</script>

<style lang="scss" module>
.reserve_top {
  display: flex;
  justify-content: center;
  padding: 90px;
  color: #fff;
  font-weight: bold;
  font-size: 40px;
  margin: 0 calc((100vw - 100%) / (-2));
  position: relative;

  @include sm-view {
    padding: 45px;
    font-size: 25px;
  }

  &.text {
    background-color: var(--blue-main);
  }

  &.online {
    background-color: var(--orange-main);
  }

  &.virtual {
    background-color: var(--green-main);
  }

  &_icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: .2;
    font-size: 130px;

    @include sm-view {
      font-size: 90px;
    }

    &_inner {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -70%);
      font-size: 0.384em;
    }
  }

  &_text {
    text-align: center;
    i {
      font-size: 46px;
      margin-right: 10px;
      @include sm-view {
        font-size: 30px;
        margin-right: 10px;
      }
    }
  }
}
.content {
  &_top {
    text-align: center;

    &_wrap {
      background-color: #fff;
      display: flex;
      justify-content: center;
      margin: 0 calc((100vw - 100%) / (-2));
    }

    &_title {
      font-size: 40px;

      @include sm-view {
        font-size: 25px;
      }
    }

    &_subtitle {
      display: inline-block;
      background-color: var(--orange-main);
      padding: .6em 1.5em;
      border-radius: 2em;
      color: #fff;
      font-weight: 700;

      @include sm-view {
        padding: 9px 15px;
        line-height: 1;
      }

      &.virtual {
        background-color: var(--green-main);
      }
    }

    &_text {
      display: inline-block;
      p {
        padding: 0 40px;
        max-width: calc(var(--main-contents-width) + var(--main-contents-gutter) * 2);
        text-align: start;
        line-height: 2;

        @include sm-view {
          max-width: 100%;
          padding: 0 var(--main-contents-gutter);
          font-size: 14px;
        }
      }
    }
  }
}
.label {
  @include sm-view {
    width: 150px;
  }
}
.required {
  font-size: 12px;
  color: red;
  text-align: center;
}
.annotation {
  font-size: 12px;
}
.flex {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.bold {
  font-weight: bold;
}
.space {
  margin-top: 8px;
  @include sm-view {
    margin-top: 0;
  }
}

.item {
  margin-right: 10px;
}

// 企業サイト（is_company=1）: お悩み選択肢を縦並びにし、各ラベル下に企業向けサブ説明文（グレー）を表示する
.flexCompany {
  flex-direction: column;
  align-items: flex-start;

  .item {
    margin-right: 0;
    margin-bottom: 10px;
  }
}
.input_text {
  padding: 13px;
  outline: none;
  border: none;
  border-radius: 8px;
  width: 100%;
}
.textarea {
  width: 100%;
  resize: vertical;
  min-width: 152.5px;
  border: none;
  outline: none;
  border-radius: 10px;
  padding: 20px;
}
.count {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}

.other_text_label {
  font-size: 14px;
  margin-bottom: 3px;
}

.who5itemTitle {
  font-size: 15px;

  @include sm-view {
    font-size: 14px;
  }
}

.optionList {
  padding-bottom: 8px;
}

.optionItem {
  display: flex;
  align-items: center;

  & + & {
    margin-top: 6px;
  }

  label {
    margin-left: 3px;
    font-size: 14px;
    line-height: 1;

    @include sm-view {
      font-size: 13px;
    }
  }
}
.red {
  color: var(--pink);
}
.notice {
  padding: 0 40px;
}
.thumbnail {
  width: 100px;
  padding-top: 100px;
  background-size: cover;
  background-position: center;
  border-radius: 50%;
  margin-right: 20px;
  border: 1px solid rgba(#aaa, 0.3);
  &_wrap {
    margin-top: 10px;
    display: flex;
    align-items: center;
  }
  &_btn {
    display: inline-block;
    border-radius: 22px;
    padding: 6px 15px;
    font-size: 14px;
    border: 1px solid var(--black);
    &:not(:first-child) {
      margin-left: 1em;
    }
  }
}

.vcid {
  width: 200px;
}
.force_link {
  cursor: pointer;
  * {
    cursor: pointer;
  }
}
</style>
